import React from 'react';
import {
  Box, IconButton,
  Typography,
} from '@mui/material';
import { X } from 'react-feather';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';

const SlotRow = ({
  small,
  fields,
  remove,
  errors,
  fieldName,
  setValue,
  watch,
}: {
  small?: boolean
  fields: any[];
  remove: (index: number) => void;
  errors: any
  fieldName: string
  setValue: any
  watch: any
}) => {
  if (fields.length === 0) {
    return (
      <Box paddingX={2} pt="6px">
        <Typography color="#667085" fontSize="14px">Unavailable</Typography>
      </Box>

    )
  }

  return (
    <div>
      {fields.map((field) => (
        <Box key={field.id} display="flex" alignItems="center" mb={1}>

          <TimePicker
            value={watch(`${fieldName}[${field.originalIndex}].startTime`)
              ? dayjs(watch(`${fieldName}[${field.originalIndex}].startTime`), 'HH:mm')
              : null}
            onChange={(newValue) => {
              const formattedTime = newValue ? newValue.format('HH:mm') : '';
              setValue(`${fieldName}[${field.originalIndex}].startTime`, formattedTime);
            }}
            slotProps={{
              textField: {
                size: 'small',
                variant: 'outlined',
                error: !!errors?.[field.originalIndex]?.startTime,
                helperText: errors?.[field.originalIndex]?.startTime?.message,
                sx: { width: small ? '125px' : undefined, '& .MuiInputBase-input': { fontSize: small ? '14px' : undefined } }
              }
            }}
          />
          <span style={{ margin: small ? '0 4px' : '0 8px', color: '#D0D5DD' }}>—</span>
          <TimePicker
            value={watch(`${fieldName}[${field.originalIndex}].endTime`)
              ? dayjs(watch(`${fieldName}[${field.originalIndex}].endTime`), 'HH:mm')
              : null}
            onChange={(newValue) => {
              const formattedTime = newValue ? newValue.format('HH:mm') : '';
              setValue(`${fieldName}[${field.originalIndex}].endTime`, formattedTime);
            }}
            slotProps={{
              textField: {
                size: 'small',
                variant: 'outlined',
                error: !!errors?.[field.originalIndex]?.endTime,
                helperText: errors?.[field.originalIndex]?.endTime?.message,
                sx: { width: small ? '125px' : undefined, '& .MuiInputBase-input': { fontSize: small ? '14px' : undefined } }
              }
            }}
          />
          <IconButton size={small ? 'small' : 'medium'} onClick={() => remove(field.originalIndex)}>
            <X size={small ? "16px" : "18px"} color="#475467" />
          </IconButton>
        </Box>
      ))}
    </div>
  );
};

export default SlotRow;
